"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var styles_1 = require("containersRechargly/Recharges/Invoices/InvoiceActionBar/styles");
var utils_1 = require("containersRechargly/Recharges/Invoices/utils");
var DropdownLinkOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownLinkOption"));
var ClientAgreementInvoiceDropdown = function (_a) {
    var item = _a.item;
    var pdfLink = (0, utils_1.getPDFLink)(item);
    if (!pdfLink) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.InvoiceBarWrapper, __assign({ justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(DropdownWithExpandBtn_1.default, __assign({ closeOnClick: true }, { children: (0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { title: "Download PDF", href: "".concat(pdfLink) }) })) })));
};
exports.default = ClientAgreementInvoiceDropdown;
